export default __webpack_public_path__ + "static/media/Regimento Interno Vai de Ferias - 29032022.ec9ea5eb.pdf";